import dayjs from "dayjs";
import 'dayjs/locale/en-gb';

dayjs.locale('en-gb');

export function formatDate(date, format) {
  return dayjs(new Date(date)).format(format);
}